/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { UnityRootState } from "../../UnityAppStore";
import type {
  DbsError,
  DbsFlowStatus,
  DbsPollingStatus
} from "../signIn.types";

export const selectDbsFlowStatus = (state: UnityRootState): DbsFlowStatus =>
  state.signIn.dbsFlowStatus;

export const selectDbsPollingStatus = (
  state: UnityRootState
): DbsPollingStatus => state.signIn.dbsPollingStatus;

export const selectLicensePlateCode = (state: UnityRootState): string =>
  state.signIn.licensePlateCode;

export const selectLicensePlateBindingUrl = (state: UnityRootState): string =>
  state.signIn.licensePlateBindingUrl;

export const selectLicensePlateBindingCredentialUrl = (
  state: UnityRootState
): string => state.signIn.licensePlateBindingCredentialUrl;

export const selectLicensePlateExpirationTime = (
  state: UnityRootState
): string => state.signIn.licensePlateExpirationTime;

export const selectDbsError = (state: UnityRootState): DbsError | null =>
  state.signIn.dbsError;
